import React, { Component } from 'react';
import { Button } from "reactstrap"
import { fetchData } from "../common/networkRequests";
import { getRequiredField } from '../oro-module/commonFunctions';


class DeleteCustom extends Component {
  constructor(props) {
    super(props);
    this.state = {

      isSubmit: false, isEdit: false, deleteConfirm: false
    };
    // this.handleEdit = this.handleEdit.bind(this);

    // this.toggleDeletingDropdown = this.toggleDeletingDropdown.bind(this);
  }

  handleDelete = () => {
    let { editConfirm } = this.state;
    this.setState({ deleteConfirm: true })
  }

  handleConfirmCancel = () => {
    this.setState({ deleteConfirm: false })
  }

  handleConfirmDelete = async () => {
    let lgs = this.props.liftGlobalState;
    let {
      alerts,
      unsavedChanges,
      errorMessages,
      currentPage,
      pageData,
      LocalVars,
      fileFolder,
      fileFolderError,
      formElements, notifications, remoteip
    } = this.props.parentState;

    currentPage = currentPage.toLowerCase();
    const formDefinition = formElements[currentPage]["form"];
    let shouldProceed = true;
    let errors = [];
    for (var i = 0; i < formDefinition.length; i++) {
      let shouldRender = 1;
      let component = formDefinition[i];
      if (component.parents) {
        for (var j = 0; j < component.parents.length; j++) {
          let elem = component.parents[j];

          const parentVal = this.props.parentState.pageData[elem.name];

          if (
            elem.reverse &&
            ((elem.match === "exist" && parentVal) ||
              (elem.match === "value" && parentVal == elem.value))
          ) {
            shouldRender = 0;
            errors.push("1");
          } else if (
            !elem.reverse &&
            ((elem.match === "exist" && parentVal) ||
              (elem.match === "value" && parentVal == elem.value))
          ) {
            shouldRender = 1;
          } else {
            if (!elem.reverse) {
              shouldRender = 0;
            }
          }
        }
      }
    }

    // getRequiredField({shouldProceed:false,current:this})

    console.log({ shouldProceed })
    if (shouldProceed) {
      currentPage = currentPage.toLowerCase();
      const formDefinition = formElements[currentPage]["form"];

      let { token } = this.props.parentProps.parentState;

      let saveThis = JSON.parse(JSON.stringify(this.props.parentState));
      delete saveThis.formElements;
      delete saveThis.navbarProperties;
      delete saveThis.workFlowData;
      delete saveThis.LocalVars;
      delete saveThis.errorMessages;
      this.setState({ isEdit: true });
      let CBSurl = `${remoteip}/sentry`;
      let url = CBSurl;
      let method = 'post';
      // saveThis['pageData']['submittype']="delete";
      saveThis['pageData']['submit_type'] = "delete";

      let postData = { pageData };
      postData['dataType'] = 'delete';
      postData['currentPage'] = currentPage;
      postData['pageData']['submit_type'] = "delete";

      let { results, exceptions, error } = await fetchData({ url, postData, method, headers: { Authorization: `JWT ${this.props.parentProps.parentState.token}` } });

      if (error) {
        notifications = { value: "Can not connect to the main server", alertType: "warning" };
        fileFolderError = { value: "Can not connect to the main server", alertType: "warning" }
        this.props.liftGlobalState({ name: 'notifications' }, notifications);
        this.props.liftGlobalState({ name: 'fileFolderError' }, fileFolderError);
        // this.setState({ isSearch: false });
      } else if (results) {
        lgs({ name: "alerts" }, alerts);
        LocalVars["formSubmittedClass"] = "";
        lgs({ name: "LocalVars" }, LocalVars);
        let buttontype = { submit: false, search: false, edit: false }
        setTimeout(function () {
          lgs({ name: "alerts" }, []);
          lgs({ name: "showButtons" }, buttontype);
        }, 500);

        if (results[0] && results[0].failed) {
          notifications = { value: results[0].msg, alertType: "warning" };
          lgs({ name: 'notifications' }, notifications);
        } else {
          lgs({ name: 'pageData' }, {});
          notifications = { value: "Success", alertType: "warning" };
          lgs({ name: 'notifications' }, notifications);
          if (fileFolder.isOpen) {
            this.props.liftGlobalState({ name: "fileFolder" }, { isOpen: false, recordID: "", isClosing: false });
            // current.props.liftGlobalState({ name: "OriginalData" }, []);
          }
        }
      }
      else {
        if (Object.keys(exceptions).length != 0) {
          alerts.unshift({ value: exceptions.message, alertType: "danger" })
          fileFolderError = { value: exceptions.message, alertType: "danger" }
        } else {
          fileFolder.isOpen = false;
          alerts.unshift({ value: "successfully Delete Record", alertType: "success" })
          this.props.liftGlobalState({ name: 'notifications' }, {});
          this.props.liftGlobalState({ name: 'fileFolderError' }, {});

        }
        lgs({ name: "alerts" }, alerts);
        lgs({ name: "unsavedChanges" }, []);
        this.props.liftGlobalState({ name: 'notifications' }, {});
        let current = this;
        setTimeout(function () {
          lgs({ name: "alerts" }, []);
          lgs({ name: 'pageData' }, {});
        }, 2000);
      }

      this.setState({ isEdit: false });

    } else {
      // this.setState({isSubmit:false});
      alerts.unshift({
        value: "There are errors on the form shown in RED color.",
        alertType: "danger"
      });

      lgs({ name: "alerts" }, alerts);

    }

  }

  render() {
    let {
      alerts,
      unsavedChanges,
      errorMessages,
      currentPage,
      pageData,
      LocalVars,
      showButtons,
      fileFolder, formActions, formState
    } = this.props.parentState
    return (
      <div>
        {fileFolder.isOpen && formState == "delete" && (
          <div className="row">
            {!this.state.deleteConfirm && <Button
              outline
              className="col-2 offset-5"
              onClick={this.handleDelete}
              color="danger"
            >
              {" "}
              {formActions && formActions.delete && formActions.delete.text && (
                <span>{formActions.delete.text}</span>
              )}
              {(!formActions ||
                !formActions.delete ||
                !formActions.delete.text) && <span>Confirm Delete!</span>}
            </Button>}
            {this.state.deleteConfirm && <Button
              outline
              color="success"
              className={`col-1 offset-5 black-submit-button`}

              onClick={this.handleConfirmDelete}
              id="main-form-submit-button"
            >YES</Button>
            }
            {this.state.deleteConfirm && <Button
              outline
              color="danger"
              style={{ marginLeft: "5px" }}
              className={`col-1  black-submit-button`}

              onClick={this.handleConfirmCancel}
              id="main-form-submit-button"
            >Cancel</Button>
            }
          </div>
        )}
      </div>
    );
  }
}

export default DeleteCustom;